/**
 * The mapping tabs, in display order. One definition drives both the tab list and
 * the default tab the Mappings screen opens on, so the two can never disagree.
 */
const MAPPING_TABS = [
    {
        key: 'ShippingMapping',
        label: 'Shipping Method',
        description: 'Carrier and delivery options',
        icon: 'uil-truck',
        isEnabled: (instance) => Boolean(instance.isShippingMethodMappingEnable)
    },
    {
        key: 'PaymentMethod',
        label: 'Payment Method',
        description: 'Tender types on each side',
        icon: 'uil-credit-card',
        isEnabled: (instance) => Boolean(instance.isPaymentMethodMappingEnable)
    },
    {
        key: 'MultiLocation',
        label: 'Multi Location',
        description: 'Warehouses and stock sources',
        icon: 'uil-map-marker',
        isEnabled: (instance) => Boolean(instance.isMultiWarehouseAttributeMappingEnable)
    },
    {
        key: 'ProductAttributeMapping',
        label: 'Product Attribute',
        description: 'Product field to field',
        icon: 'uil-list-ul',
        isEnabled: (instance) => Boolean(instance.isProductAttributeMappingEnable)
    },
    {
        key: 'CustomerAttributeMapping',
        label: 'Customer Attribute',
        description: 'Customer field to field',
        icon: 'uil-user-circle',
        isEnabled: (instance) => Boolean(instance.isCustomerAttributeMappingEnable)
    },
    {
        key: 'SalesPersonMapping',
        label: 'Sales Person',
        description: 'Reps across both systems',
        icon: 'uil-users-alt',
        isEnabled: (instance) => Boolean(instance.isSalesPersonMappingEnable)
    }
]

export const enabledMappingTabs = (instance) =>
    MAPPING_TABS.filter((tab) => tab.isEnabled(instance || {}))

export default MAPPING_TABS
